/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { SetStateAction } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { TestIds } from "../../../../testIds";
import { useBranch } from "../../../../util/useBranch";
import { selectPickupStores } from "../../../stores/storage/stores.slice";
import StoreAvailabilityModal from "../StockAvailability/StoreAvailabilityModal";

interface StoreModalContainerProps {
  open: boolean;
  setOpen: (open: SetStateAction<boolean>) => void;
}

export const StoreModalContainer = ({ open, setOpen }: StoreModalContainerProps) => {
  const { masterProductId } = useParams<{ masterProductId: string }>();
  const productId = masterProductId ? parseInt(masterProductId) : undefined;
  const stores = useSelector(selectPickupStores);
  const branchId = useBranch();
  const selectedStore = stores.find((x) => x.inventorySiteId === branchId);

  if (!productId) {
    return null;
  }

  return (
    <StoreAvailabilityModal
      open={open}
      setOpen={setOpen}
      productId={productId}
      selectedStore={selectedStore}
      testId={TestIds.feat.stock.storeAvailabilitiesModal}
    />
  );
};
